const Menu = [
  {
    label: 'Home',
    pathname: '/main',
    display: false,
  },
  {
    label: 'About',
    pathname: '/about/vision',
    display: true,
    children: [
      {
        label: 'Vision',
        pathname: '/about/vision',
        display: true,
      },
      {
        label: 'Organization Chart',
        pathname: '/about/organization',
        display: true,
      },
    ],
  },
  {
    label: 'Business',
    pathname: '/business/scope',
    display: true,
    children: [
      {
        label: 'Business Scope',
        pathname: '/business/scope',
        display: true,
      },
      {
        label: 'Clients',
        pathname: '/business/client',
        display: true,
      },
    ],
  },
  {
    label: 'Project',
    pathname: '/project',
    display: true,
    children: [
      {
        label: 'Pharmaceutical',
        pathname: '/project/1',
        display: true,
      },
      {
        label: 'Medical Society',
        pathname: '/project/2',
        display: true,
      },
      {
        label: 'Non Medical',
        pathname: '/project/3',
        display: true,
      },
      {
        label: 'Creative Design',
        pathname: '/project/4',
        display: true,
      },
    ],
  },
  {
    label: 'Contact us',
    pathname: '/contact/inquiry',
    display: true,
    children: [
      {
        label: 'Inquiry',
        pathname: '/contact/inquiry',
        display: true,
      },
    ],
  },
];

export default Menu;
